import React from "react";
import { Input, Radio, Space } from "antd";

export default function TtRadioButton(props) {
  const { component, currentConfig, handleChange, toIntIf } = props;
  return (
    <div style={{ marginBottom: 130 }}>
      <Radio.Group
        value={currentConfig[component.name] || null}
        name={component.name}
        buttonStyle="solid"
        onChange={(e) => {
          const value = e.target.value;
          handleChange({ [component.name]: toIntIf(value) });
        }}
      >
        <div style={{ display: "flex" }}>
          {component.permittedValues.map((v) => {
            if (typeof v === "object" && v !== null) {
              return (
                <Radio.Button
                  value={v.code}
                  style={{ display: "block", height: "100px", width: "230px" }}
                >
                  <div style={{ width: 230, height: 100, overflow: "hidden" }}>
                    <img
                      src={`${process.env.REACT_APP_IMAGE_PATH}${v.file}.png`}
                      style={{ maxWidth: "200px", display: "block" }}
                    ></img>
                  </div>
                  {v.description}
                </Radio.Button>
              );
            }
            return (
              <Radio.Button
                value={v}
                style={{ display: "block", minHeight: "100px" }}
              >
                <img
                  src="https://terotero.it/img/original/loghi/terotero-icon1.png"
                  style={{ maxWidth: "100px", display: "block" }}
                ></img>
                {v}
              </Radio.Button>
            );
          })}
        </div>
      </Radio.Group>
    </div>
  );
}
